import { FC, memo } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

interface FullPageAnimatorProps {
  className?: string;
  lottie?: string;
}

const FullPageAnimator: FC<FullPageAnimatorProps> = ({ className = '', lottie = '' }) =>
  lottie ? (
    <div className={`tw-fixed tw-top-1/2 tw-left-1/2 tw-z-50 -tw-translate-x-1/2 -tw-translate-y-1/2 ${className}`}>
      {lottie && (
        <Player src={JSON.parse(lottie)} className='lottie-player' autoplay keepLastFrame style={{ height: '400px' }} />
      )}
    </div>
  ) : null;

export default memo(FullPageAnimator);
